import Swiper, { Navigation } from 'swiper';

class GallerySlider {
  constructor(el) {
    this.el = el;
    Swiper.use([Navigation]);

    this.initSlider();
  }

  initSlider() {
    new Swiper(this.el.querySelector('.swiper'), {
      speed: 400,
      spaceBetween: 64,
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 5,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          spaceBetween: 10,
        },
        // when window width is >= 640px
        767: {
          spaceBetween: 64,
        },
      },
    });
  }
}

export default GallerySlider;
